export function select() {
    require('selectize')
    $('.selectize').selectize({
        wrapperClass: 'selectize-control-outline',
    })
}



/** WEBPACK FOOTER **
 ** ./assets/app/component/select/select.js
 **/